import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Input } from '../ui/input';

export const QuickSearchBar = () => {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <section className="py-4 bg-white border-b border-gray-200 sticky top-[104px] z-40 shadow-sm">
      <div className="max-w-7xl mx-auto px-6">
        {/* Search Bar */}
        <div className="flex items-center justify-between">
          <div className="flex-1 max-w-2xl">
            <form onSubmit={(e) => { e.preventDefault(); if(searchQuery.trim()) window.location.href = `/products?search=${encodeURIComponent(searchQuery)}`; }}>
              <div className="relative">
                <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
                <Input
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search freeze dryers, accessories, recipes..."
                  className="pl-12 py-3 text-base rounded-full border-gray-300 h-12 w-full"
                  data-testid="hero-search"
                />
              </div>
            </form>
          </div>
          {/* Desktop Links */}
          <div className="hidden lg:flex items-center gap-8 ml-8">
            <Link to="/products?category=freeze-dryer" className="text-gray-700 hover:text-[#003456] font-medium text-sm">Freeze Dryers</Link>
            <Link to="/products?category=accessory" className="text-gray-700 hover:text-[#003456] font-medium text-sm">Accessories</Link>
            <Link to="/financing" className="text-gray-700 hover:text-[#003456] font-medium text-sm">Financing</Link>
            <Link to="/track-order" className="text-gray-700 hover:text-[#003456] font-medium text-sm">Track Order</Link>
          </div>
        </div>
        
        {/* Mobile Quick Links */}
        <div className="flex lg:hidden items-center justify-center gap-4 mt-3 pt-3 border-t border-gray-100 overflow-x-auto">
          <Link to="/products?category=freeze-dryer" className="text-gray-600 hover:text-[#003456] font-medium text-xs whitespace-nowrap px-2">Freeze Dryers</Link>
          <span className="text-gray-300">|</span>
          <Link to="/products?category=accessory" className="text-gray-600 hover:text-[#003456] font-medium text-xs whitespace-nowrap px-2">Accessories</Link>
          <span className="text-gray-300">|</span>
          <Link to="/financing" className="text-gray-600 hover:text-[#003456] font-medium text-xs whitespace-nowrap px-2">Financing</Link>
          <span className="text-gray-300">|</span>
          <Link to="/track-order" className="text-gray-600 hover:text-[#003456] font-medium text-xs whitespace-nowrap px-2">Track Order</Link>
        </div>
      </div>
    </section>
  );
};

export default QuickSearchBar;
